import endOfDay from 'date-fns/endOfDay';
import subHours from 'date-fns/subHours';
import format from 'date-fns/format';

import safeValue from '../helpers/safeValue';

const mapSubmitObject = (values) => {
  const mappedValues = { ...values };
  // normalize report type
  if (values.reportType?.first && values.reportType?.second) {
    mappedValues.reportType = `${values.reportType.first}, ${
      values.reportType.second
    }`;
  } else if (values.reportType?.first) {
    mappedValues.reportType = values.reportType.first;
  } else if (values.reportType?.second) {
    mappedValues.reportType = values.reportType.second;
  }
  // handle FHA
  if (values.fha === 'No') {
    delete mappedValues.fhaCaseNumber;
  } else if (values.fhaCaseNumber) {
    mappedValues.fhaCaseNumber = values.fhaCaseNumber.replace(/-/g, '');
  }
  // handle attached credit card
  if (values.paymentMethodId) {
    mappedValues.integrations = [
      {
        key: 'payment_method',
        source: 'stripe',
        value: values.paymentMethodId,
      },
    ];
    if (values.paymentCustomerId) {
      mappedValues.integrations.push(   {
        key: 'customer_id',
        source: 'stripe',
        value: values.paymentCustomerId,
      },)
    }
  }
  // handle Purchase price
  if (values.purchasePrice) {
    // Safely convert string to number
    mappedValues.purchasePrice = +values.purchasePrice
      .replace(',', '.')
      .replace(/[^\d.]/g, '')
      .replace(/\./, 'x')
      .replace(/\./g, '')
      .replace(/x/, '.');
  }
  // handle phone number for Contact For Access
  if (Array.isArray(values.contactForAccess?.phoneNumbers)) {
    if (values.contactForAccess?.phoneNumbers[0]?.phone) {
      mappedValues.contactForAccess.phoneNumbers[0].type = 'primary';
    } else {
      delete mappedValues.contactForAccess.phoneNumbers;
    }
  }
  // set dueDate to 5 PM
  if (values.dueDate) {
    mappedValues.dueDate = format(
      subHours(endOfDay(values.dueDate), 7),
      "yyyy-MM-dd'T'HH:mm:ss.SSS",
    );
  }
  // normalize contact for access
  if (values.contactForAccess && !values.contactForAccess.companyName) {
    delete mappedValues.contactForAccess;
  }
  // Normalize contactForAccess name
  if (mappedValues.contactForAccess) {
    const name = values.contactForAccess.companyName.trim().split(' ');
    mappedValues.contactForAccess.name = {
      first: name.shift(),
      last: `${name.join(', ') || ' '}`,
    };
  }
  // Handle phone number for property owner
  if (values.propertyOwner?.phone) {
    mappedValues.propertyOwner.phoneNumbers = [
      {
        type: 'primary',
        phone: values.propertyOwner.phone,
      },
    ];
    delete mappedValues.propertyOwner.phone;
  }
  mappedValues.notes = [];
  // convert instructions into notes
  if (values.contactForAccess?.notes) {
    mappedValues.notes.push(values.contactForAccess.notes);
  }
  // handle notes
  if (values.sharedNote) {
    mappedValues.notes.push(values.sharedNote);
  }
  if (values.billingContact) {
    mappedValues.notes.push(`Billing Info:
Name: ${values.billingContact.name}
Email: ${safeValue(values.billingContact.email)}
Phone: ${safeValue(values.billingContact.phone)}`);
  }
  // handle addressed to rich object
  if (values.addressToMe) {
    mappedValues.addressedTo = {
      name: {
        first: window.UserFirstName,
        last: window.UserLastName,
      },
      email: window.anowUserEmail,
    };
    if (values.anowUser.name) {
      mappedValues.addressedTo.companyName = values.anowUser.name;
    }
    if (values.anowUser.phoneNumbers) {
      mappedValues.addressedTo.phoneNumbers = [
        {
          type: 'primary',
          phone: values.anowUser.phoneNumbers,
        },
      ];
    }
  }
  // add source
  mappedValues.source = 'anow-connect';
  if (!window.isAuthenticated) {
    mappedValues.source = 'anow-connect-anon';
    const orderedBy = {
      companyName: values.orderedBy.name,
      email: values.orderedBy.email,
      phoneNumbers: [
        {
          "type": "primary",
          phone: values.orderedBy.phone
        }
      ]
    }
    mappedValues.orderedBy = orderedBy;
    mappedValues.requester = orderedBy;
  }
  // cleanup final object
  delete mappedValues.anowUser;
  return mappedValues;
};

export default mapSubmitObject;
